module.exports = __webpack_public_path__ + "img/badge-network-gold-brightbg.802d5942.svg";